(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('CadastroPropriedadeCtrl', CadastroPropriedadeCtrl);

  CadastroPropriedadeCtrl.$inject = [
    '$location',
    '$rootScope',
    '$routeParams',
    'LoadingService',
    'PropriedadesService',
    'Flash',
    'CidadesService'
  ];
  // eslint-disable-next-line max-params, max-lines-per-function
  function CadastroPropriedadeCtrl($location, $rootScope, $routeParams,
    LoadingService, PropriedadesService, Flash, CidadesService) {
    const vm = this;
    vm.ufs = [
      'AC',
      'AL',
      'AM',
      'AP',
      'BA',
      'CE',
      'DF',
      'ES',
      'GO',
      'MA',
      'MG',
      'MS',
      'MT',
      'PA',
      'PB',
      'PE',
      'PI',
      'PR',
      'RJ',
      'RN',
      'RO',
      'RR',
      'RS',
      'SC',
      'SE',
      'SP',
      'TO'
    ];

    vm.filters = {
      uf: ''
    };

    const error = function() {
      Flash.create(FALHA_AO_CONSULTAR_REGISTRO.type, FALHA_AO_CONSULTAR_REGISTRO.msg);
      $location.path('/cadastro_propriedades');
    };

    const initialize = function() {
      LoadingService.showLoading();
      $rootScope.initialize.then(function() {
        if (!$rootScope.permissions.propriedades.canManage) {
          $location.path('/');
          Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
          return;
        }

        if ($routeParams.id) {
          PropriedadesService.get($routeParams.id)
            .then(function(data) {
              vm.propriedade = data.data || {};
              if (!vm.propriedade.id) {
                error();
              } else {
                vm.filters.uf = _.get(vm.propriedade, 'cidade.uf');
              }
            })
            .then(vm.changeUf)
            .catch(error)
            .finally(LoadingService.hideLoading);
        } else {
          vm.propriedade = {};
          LoadingService.hideLoading();
        }
      });
    };

    initialize();

    vm.changeUf = function() {
      if (!vm.filters.uf) {
        return;
      }

      LoadingService.showLoading();

      CidadesService
        .list(vm.filters)
        .then((data) => {
          vm.cidades = data.data;
        })
        .catch((err) => {
          Flash.create(FALHA_AO_CONSULTAR_REGISTRO.type, 'Ocorreu um erro ao consultar as cidades da UF');
          console.error(err);
        })
        .finally(LoadingService.hideLoading);
    };

    vm.goToIndex = function() {
      $location.path('/cadastro_propriedades');
    };

    vm.goToShow = function() {
      $location.path(`/cadastro_propriedades/${ (vm.propriedade || {}).id}`);
    };

    vm.save = function(form) {
      if (form.$invalid) {
        return;
      }

      LoadingService.showLoading();
      PropriedadesService.save(vm.propriedade).then(function(result) {
        vm.propriedade.id = result.data.id;
        vm.goToShow();
        Flash.create(REGISTRO_SALVO_COM_SUCESSO.type, REGISTRO_SALVO_COM_SUCESSO.msg);
      })
        .catch(function() {
          Flash.create(FALHA_AO_SALVAR_REGISTRO.type, FALHA_AO_SALVAR_REGISTRO.msg);
        })
        .finally(LoadingService.hideLoading);
    };
  }
}());
